// src/components/ProtectedRoute.js
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const roleDashboard = (role) => {
  switch ((role || "").toString().toLowerCase()) {
    case "admin":
    case "secretary":
      return "/admin";
    case "district":
      return "/district";
    case "player":
      return "/player";
    case "coach":
      return "/coach";
    default:
      return "/login";
  }
};

const getStoredAuth = () => {
  if (typeof window === "undefined") return { token: null, user: null, role: null };
  try {
    const token = sessionStorage.getItem("token");
    const role = sessionStorage.getItem("role");
    const rawUser = sessionStorage.getItem("user");
    const user = rawUser ? JSON.parse(rawUser) : null;
    return { token, user, role };
  } catch {
    return { token: null, user: null, role: null };
  }
};

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { token, user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;

  const stored = getStoredAuth();
  const effectiveToken = token || stored.token;
  const effectiveUser = user || stored.user;

  // Not authenticated → go to login
  if (!effectiveToken || !effectiveUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const role = (effectiveUser.role || stored.role || "").toString().toLowerCase();
    const allowed = allowedRoles.map((r) => r.toString().toLowerCase());
    if (!allowed.includes(role)) {
      // Coach access always starts from the shared login screen, which asks
      // dual-role users to choose Player or Coach after credential validation.
      if (allowed.includes("coach")) {
        return <Navigate to="/login?switch=true" replace state={{ from: location }} />;
      }
      // Redirect to their correct dashboard instead of login
      return <Navigate to={roleDashboard(role)} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
